import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClipboardTableService {
  /** Copies a table so it pastes cell-wise into a spreadsheet.
   *  `headers` and each row are already string-rendered. */
  async copyTable(headers: string[], rows: string[][]): Promise<void> {
    const esc = (s: string) => String(s ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const tsv = [headers, ...rows].map(r => r.join('\t')).join('\n');
    const html =
      `<table><thead><tr>${headers.map(h => `<th>${esc(h)}</th>`).join('')}</tr></thead>` +
      `<tbody>${rows.map(r => `<tr>${r.map(c => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody></table>`;

    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([tsv], { type: 'text/plain' }),
          'text/html': new Blob([html], { type: 'text/html' }),
        }),
      ]);
    } catch {
      await navigator.clipboard.writeText(tsv);
    }
  }
}
